export interface BaoItem {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  tag: string;
  heat: string;
  comments: number;
  likes: number;
  time: string;
  badge?: string;
  gradient: string;
  icon: string;
}

export const hotRanks: BaoItem[] = [
  {
    id: 1,
    title: "年度现象级音综收官夜，网友直呼意难平",
    category: "娱乐",
    excerpt: "从初舞台到总决赛，选手成长线引发热议，相关话题阅读量持续走高。",
    tag: "爆",
    heat: "982万",
    comments: 12843,
    likes: 51230,
    time: "2小时前",
    gradient: "from-rose-500 to-orange-400",
    icon: "ri-mic-fill",
  },
  {
    id: 2,
    title: "某新锐数码品牌发布折叠屏新机，配置争议两极分化",
    category: "科技",
    excerpt: "售价与铰链工艺成为讨论焦点，站队与质疑的声音同时存在。",
    tag: "热",
    heat: "815万",
    comments: 10271,
    likes: 34820,
    time: "3小时前",
    gradient: "from-emerald-500 to-teal-400",
    icon: "ri-smartphone-line",
  },
  {
    id: 3,
    title: "职场'摸鱼经济学'刷屏：年轻人为何追求高效工作时长",
    category: "职场",
    excerpt: "一则关于工作时长与产出效率的讨论帖，引发大量打工人共鸣。",
    heat: "720万",
    comments: 9832,
    likes: 27650,
    time: "4小时前",
    gradient: "from-amber-500 to-yellow-400",
    icon: "ri-briefcase-4-line",
  },
  {
    id: 4,
    title: "景区文创雪糕又出圈，颜值口味能否留住游客",
    category: "生活",
    excerpt: "多地景区花式上新文创雪糕，网友晒图打卡热情高涨。",
    tag: "新",
    heat: "668万",
    comments: 7456,
    likes: 20314,
    time: "5小时前",
    gradient: "from-pink-500 to-fuchsia-400",
    icon: "ri-emotion-happy-line",
  },
  {
    id: 5,
    title: "小众旅行目的地走红背后：是宝藏还是被过度营销",
    category: "旅行",
    excerpt: "几座原本冷门的西北小城突然刷屏，真实体验与滤镜呈现差距引热议。",
    heat: "604万",
    comments: 6903,
    likes: 18740,
    time: "6小时前",
    gradient: "from-sky-400 to-cyan-300",
    icon: "ri-flight-takeoff-line",
  },
  {
    id: 6,
    title: "营养早餐新宠燕麦碗，配料表里藏着多少套路",
    category: "消费",
    excerpt: "减脂人群追捧的高颜值早餐，含糖量问题让不少人直呼上当。",
    heat: "551万",
    comments: 6128,
    likes: 16203,
    time: "7小时前",
    gradient: "from-lime-500 to-green-400",
    icon: "ri-restaurant-fill",
  },
  {
    id: 7,
    title: "被催婚的年轻人：今年过年你准备怎么'过关'",
    category: "社会",
    excerpt: "团圆时节的家庭议题登上热搜，网友纷纷支招分享应对技巧。",
    heat: "489万",
    comments: 5801,
    likes: 13872,
    time: "8小时前",
    gradient: "from-orange-500 to-red-400",
    icon: "ri-home-heart-line",
  },
  {
    id: 8,
    title: "动画电影续作口碑发酵，国漫之路越走越稳",
    category: "娱乐",
    excerpt: "精良制作与东方美学获得好评，评论区'自来水'安利不断。",
    tag: "爆",
    heat: "472万",
    comments: 5467,
    likes: 22980,
    time: "9小时前",
    gradient: "from-indigo-500 to-violet-400",
    icon: "ri-movie-2-fill",
  },
];

export const categoryList = [
  { name: "娱乐", icon: "ri-mic-fill", color: "text-rose-600 bg-rose-100", desc: "影视音综明星动态", count: 1280 },
  { name: "消费", icon: "ri-shopping-bag-3-fill", color: "text-emerald-600 bg-emerald-100", desc: "好物吐槽避坑", count: 968 },
  { name: "职场", icon: "ri-briefcase-4-fill", color: "text-amber-600 bg-amber-100", desc: "职场见闻与心得", count: 745 },
  { name: "科技", icon: "ri-smartphone-line", color: "text-teal-600 bg-teal-100", desc: "新品首发评测", count: 682 },
  { name: "生活", icon: "ri-cup-line", color: "text-orange-600 bg-orange-100", desc: "吃喝玩乐趣事", count: 1540 },
  { name: "社会", icon: "ri-global-line", color: "text-rose-500 bg-rose-50", desc: "热点事件观察", count: 913 },
];

export const commentsData = [
  {
    user: "一颗柠檬不加糖",
    avatar: "柠",
    time: "12分钟前",
    text: "终于有人说到点子上了！我之前就发现了这个问题，还好有吃瓜群众一起讨论，不然一个人都不敢说。",
    likes: 356,
    replies: 18,
    color: "bg-emerald-500",
  },
  {
    user: "熬夜冠军阿泽",
    avatar: "阿",
    time: "36分钟前",
    text: "前排吃瓜！这条线索确实够劲爆，蹲一个后续，希望楼主办证再放实锤。",
    likes: 289,
    replies: 12,
    color: "bg-rose-500",
  },
  {
    user: "理性看客老周",
    avatar: "周",
    time: "1小时前",
    text: "大家先别急着站队，等更多信源确认再下结论。理性吃瓜才更有意思，避免误伤路人。",
    likes: 431,
    replies: 25,
    color: "bg-amber-500",
  },
  {
    user: "奶茶五分甜",
    avatar: "甜",
    time: "2小时前",
    text: "这条爆料内容很详细，看得出是认真整理过的。评论区氛围也不错，大家都挺有梗的哈哈。",
    likes: 198,
    replies: 9,
    color: "bg-teal-500",
  },
];

export const faqData = [
  {
    q: "什么是爆瓜网？",
    a: "爆瓜网是一个开放给网友的吃瓜爆料与互动平台。你可以在这里浏览当下热门的娱乐、消费、职场、科技等话题讨论，也可以上传你掌握的真实线索，与千万吃瓜群众一起围观、评论和参与讨论。",
  },
  {
    q: "如何在爆瓜网上传爆料？",
    a: "在网站顶部点击「立即投稿」，或进入首页底部的「投稿通道」板块，填写话题标题、所属分类、事件描述以及可选的联系方式后提交即可。审核通过后的内容会进入对应专区，被更多网友看到。",
  },
  {
    q: "投稿内容需要满足哪些要求？",
    a: "请确保内容真实可靠，不包含虚构事实、人身攻击、未经证实的指控或违法信息。为保护隐私，请对涉及的个人信息进行适当脱敏处理。建议提供尽量清晰的事件时间、地点和经过，帮助其他网友理解。",
  },
  {
    q: "投稿后多久能看到我的内容？",
    a: "普通投稿通常在 24 小时内完成审核。审核通过后会立即展示在对应分类与最新爆料流中。若投稿内容较复杂需要进一步核实，审核时间会相应延长，我们会在后台与您沟通进度。",
  },
  {
    q: "发现内容不实或侵权，如何举报？",
    a: "每条内容都设有举报入口，你也可以通过页面底部的联系邮箱提交举报，说明具体链接与理由。我们会在 3 个工作日内核实处理，并对不实内容或侵犯他人权益的投稿按规则处理。",
  },
  {
    q: "爆瓜网是免费的吗？",
    a: "爆瓜网面向所有用户免费开放浏览、评论与投稿等基础功能。我们坚持让真实的声音被更多人听见，不会向普通用户收取任何费用。未来如有会员增值服务，会提前公告并明确规则。",
  },
];